var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.4465116,7.38232558 C128.714419,-0.893023256 164.375814,3.92930233 192.833488,21.492093 C228.673488,42.9246512 252.070698,83.467907 252.666047,125.20186 C253.975814,167.352558 232.007442,209.146047 196.703256,232.066977 C157.410233,258.500465 103.054884,259.512558 62.9283721,234.388837 C22.027907,209.979535 -1.8455814,160.744186 4.28651163,113.473488 C9.22790698,63.5237209 47.8065116,19.467907 96.4465116,7.38232558 L96.4465116,7.38232558 L96.4465116,7.38232558 Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5051163,27.8027907 C152.468837,3.39348837 227.244651,48.4613953 233.555349,113.830698 C243.378605,172.651163 194.56,232.424186 134.965581,234.150698 C78.2883721,239.806512 23.5162791,191.76186 21.9088372,134.846512 C17.6818605,88.7665116 48.0446512,43.0437209 91.5051163,27.8027907 L91.5051163,27.8027907 L91.5051163,27.8027907 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6372093,121.689302 C124.963721,99.3637209 151.694884,76.264186 179.616744,54.5934884 C164.971163,77.0976744 149.908837,99.304186 135.263256,121.808372 C122.701395,121.867907 110.139535,121.867907 97.6372093,121.689302 L97.6372093,121.689302 L97.6372093,121.689302 Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.736744,134.132093 C133.35814,134.132093 145.92,134.132093 158.48186,134.310698 C130.976744,156.517209 104.364651,179.795349 76.3832558,201.406512 C91.0288372,178.902326 106.091163,156.636279 120.736744,134.132093 L120.736744,134.132093 L120.736744,134.132093 Z",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocket);
export default __webpack_public_path__ + "static/media/socket.9e0bfcf66af51e8d702db77ebc1ebdf0.svg";
export { ForwardRef as ReactComponent };